// extracted by mini-css-extract-plugin
export default {"container":"fileUploader_container__C5WB6","button":"fileUploader_button__HmKEd","errorIcon":"fileUploader_errorIcon__ljw3Z","error":"fileUploader_error__OCocR"};